<template>
  <div>
    <h2 :class="$style.header">
      <span :class="$style.title" class="mb-2">热搜排行榜</span>
    </h2>
    <ul>
      <li v-for="(item, index) in list" :key="item.no" :class="$style.item">
        <div :class="$style.itemSerial">
          {{ index + 1 }}
        </div>
        <div :class="$style.itemContent">
          <h3 :class="$style.itemTitle">
            <nuxt-link target="_blank" :to="`/company/article/${item.no}`" :title="item.title">
              {{ item.title }}
            </nuxt-link>
          </h3>
          <p :class="$style.itemDesc">
            {{ item.pageviews }}次阅读
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { onBeforeMount, defineComponent } from "@nuxtjs/composition-api";
import useRequest from "~/composables/useRequest";
import { getHotSearchTop } from "~/services/company";
export default defineComponent({
  name: 'HotSearchList',
  setup() {
    const { execute, state } = useRequest(getHotSearchTop, [], {
      immediate: false,
    });

    onBeforeMount(async () => {
      await execute(0);
    });

    return {
      list: state,
    };
  },
});
</script>
<style lang="scss" module>
.header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  margin-bottom: 0.75rem;
}
.title {
  font-weight: 600;
  font-size: 1.625rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.item ~ * {
  margin-top: 0.75rem;
}
.item:nth-child(1) .itemSerial {
  background: rgba(#ffe6bb, 0.29);
  color: #e23328;
}
.item:nth-child(2) .itemSerial {
  background: rgba(#ffe6bb, 0.29);
  color: #f2803b;
}
.item:nth-child(3) .itemSerial {
  background: rgba(#ffe6bb, 0.29);
  color: #fea426;
}
.itemSerial {
  border-radius: 9999px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: -webkit-inline-flex;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  font-weight: 600;
  height: 1.5rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
  line-height: 1;
  --tw-text-opacity: 1;
  color: rgba(164, 168, 180, var(--tw-text-opacity));
  width: 1.5rem;
  background: rgba(#cacaca, 0.29);
}
.itemContent {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0%;
  -webkit-flex: 1 1 0%;
  flex: 1 1 0%;
  margin-left: 0.75rem;
}
.itemTitle {
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
  -webkit-transition-property: background-color, border-color, color, fill, stroke;
  -o-transition-property: background-color, border-color, color, fill, stroke;
  transition-property: background-color, border-color, color, fill, stroke;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.itemTitle:hover {
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
}
.itemDesc {
  font-size: 0.8125rem;
  line-height: 1.125rem;
  margin-top: 2px;
  --tw-text-opacity: 1;
  color: rgba(164, 168, 180, var(--tw-text-opacity));
}
</style>